import React, { Component } from "react";
import * as _ from "lodash";
import { Helmet } from "react-helmet";

import Header from "./components/header/header";
import CoreSection from "./components/coreSection/coreSections";
import ValueSection from "./components/valueSection/valueSection";
import GridSection from "./components/gridSection/gridSection";
import Seperator from "../../components/seperator/seperator";
import ContactSection from "./components/contactSection/contactSection";
import Footer from "../../components/footer/footer";
import Row from "./../../components/row/row";
import LanguageSwitcher from "./../../components/languageSwitcher/languageSwitcher";

export default class Landing extends Component {
  render() {
    const { pathContext, location } = this.props;
    const { landingLanguages } = pathContext;

    const isEnglish = _.chain(location.pathname)
      .split("/")
      .compact()
      .includes("en")
      .value();
    const gridColumns = isEnglish ? 3 : 2;
    const currentLanguage = isEnglish ? "en" : "de";

    return (
      <div>
        <Helmet title={landingLanguages.title} />
        <Row displayFlex={false} padding={false}>
          <LanguageSwitcher currentLanguage={currentLanguage} />
        </Row>
        <Header titleDescription={landingLanguages.titleDescription} />
        <CoreSection
          title={landingLanguages.coreSectionHeadline}
          description={landingLanguages.coreSectionDescription}
        />
        <ValueSection
          valueSectionDescription={landingLanguages.valueSectionDescription}
          valueSectionFunctionality={landingLanguages.valueSectionFunctionality}
          valueSectionHeadline={landingLanguages.valueSectionHeadline}
        />
        <GridSection
          className="features"
          features={landingLanguages.features}
          featureSectionHeadline={landingLanguages.featureSectionHeadline}
          columns={gridColumns}
        />
        <Row displayFlex={false} padding={false}>
          <Seperator width="auto" color={["#2399dd", "#51e4c0"]} height="1px" />
        </Row>
        <GridSection
          className="tools"
          features={landingLanguages.tools}
          featureSectionHeadline={landingLanguages.toolsSectionHeadline}
          columns={2}
        />
        <ContactSection translations={landingLanguages} />
        <Footer
          imprint={landingLanguages.imprint}
          copyright={landingLanguages.copyright}
          campudusClaim={landingLanguages.campudusClaim}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/templates/landing/landing.js